/**
 * Formata número de telefone brasileiro no padrão (99) 99999-9999 ou (99) 9999-9999
 */
export function formatPhoneNumber(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 11);

  if (digits.length <= 2) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
}

/**
 * Normaliza número para padrão internacional E.164 (ex: 5511999999999)
 */
export function normalizePhoneToE164(phone: string, defaultCountry = '55'): string {
  const digits = phone.replace(/\D/g, '');
  if (digits.startsWith('55') && digits.length >= 12) {
    return digits;
  }
  return `${defaultCountry}${digits}`;
}

/**
 * Sanitiza texto prevenindo caracteres que induzam injeção de fórmulas CSV (=, +, -, @)
 */
export function sanitizeForCsv(value: string): string {
  if (!value) return '';
  const trimmed = value.trim();
  if (['=', '+', '-', '@', '\t', '\r'].some((char) => trimmed.startsWith(char))) {
    return `'${trimmed}`;
  }
  return trimmed;
}
